/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const RadioPlay = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7752 6.55806C14.9251 8.01952 16 8.75026 16 10.0001C16 11.2499 14.9251 11.9806 12.7752 13.4421C12.1817 13.8455 11.5931 14.2253 11.0522 14.5419C10.5777 14.8195 10.0403 15.1068 9.48387 15.3887C7.33906 16.4756 6.26666 17.0191 5.30483 16.4174C4.343 15.8157 4.25559 14.5561 4.08076 12.037C4.03132 11.3246 4 10.6262 4 10.0001C4 9.37396 4.03132 8.67556 4.08076 7.96314C4.25559 5.44398 4.343 4.1844 5.30483 3.58272C6.26666 2.98104 7.33906 3.52448 9.48387 4.61137C10.0403 4.89333 10.5777 5.18057 11.0522 5.45825C11.5931 5.77477 12.1817 6.15462 12.7752 6.55806Z"
      stroke={props.color ?? props?.style?.color}
      strokeWidth="1.5"
    />
  </svg>
);

export default RadioPlay;
